// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__223sF","title":"styles_title__3-xBb"};